import React, { forwardRef, useCallback } from 'react';
import {
  IconButton,
  InputAdornment,
  TextField,
} from '@mui/material';

const SignedNumberField = forwardRef(({
  InputProps = {},
  inputProps = {},
  onChange,
  value,
  ...props
}, ref) => {
  const numericValue = Number(value);
  const hasToggleableValue = value !== '' && value !== null && value !== undefined &&
    Number.isFinite(numericValue) && numericValue !== 0;
  const isNegative = String(value ?? '').startsWith('-');

  const handleSignToggle = useCallback(() => {
    if (!hasToggleableValue || !onChange) return;

    const currentValue = String(value);
    const nextValue = isNegative ? currentValue.slice(1) : `-${currentValue}`;

    onChange({
      target: { type: 'number', value: nextValue },
      currentTarget: { type: 'number', value: nextValue },
    });
  }, [hasToggleableValue, isNegative, onChange, value]);

  return (
    <TextField
      {...props}
      ref={ref}
      type="number"
      value={value}
      onChange={onChange}
      inputProps={{
        inputMode: 'decimal',
        step: 'any',
        ...inputProps,
      }}
      InputProps={{
        ...InputProps,
        startAdornment: (
          <>
            <InputAdornment position="start">
              <IconButton
                aria-label={isNegative ? 'Make value positive' : 'Make value negative'}
                disabled={!hasToggleableValue}
                edge="start"
                onClick={handleSignToggle}
                onMouseDown={(event) => event.preventDefault()}
                size="small"
                title={isNegative ? 'Make positive' : 'Make negative'}
              >
                ±
              </IconButton>
            </InputAdornment>
            {InputProps.startAdornment}
          </>
        ),
      }}
    />
  );
});

SignedNumberField.displayName = 'SignedNumberField';

export default SignedNumberField;
